module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-ceremony-producer-803491366ff5dffb45cad58271ea6984.jpg";